import React , {Component} from 'react'
import classnames from 'classnames'
import {  NavItem, NavLink } from 'reactstrap'
import { Link, NavLink as RRNavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import MediaQuerySelectors from "redux-modules/media-query/MediaQuerySelectors";
let NavbarHeight = 60;


class NavbarSpacer  extends Component {


    render () {
        return (
            <div style={{height: this.props.isMobile?NavbarHeight - 4 +'px': '0px'}}>
            </div>
        )
    }
}
const mapDispatchToProps = {
}

const mapStateToProps = (state, props) => ({

    isMobile: MediaQuerySelectors.isMobileSelector(state, props)
})


export default connect(mapStateToProps, mapDispatchToProps )(NavbarSpacer)





// WEBPACK FOOTER //
// ./src/components/navbar/NavbarSpacer.js